// eslint-disable-next-line max-classes-per-file
import React from 'react'
import { FormItem, FormItemProps } from './FormItem'
import { IField, getRequiredError } from './FieldValidation'
import { Option } from './Options'
import { ErrorText } from './ErrorText'
import { Checkbox } from './Checkbox'

export interface CheckboxGroupFieldProps<V> extends FormItemProps {
    id: string
    onChange: { (value: V[]): any },
    value: V[],
    dataSource: Option<V>[]
    required?: boolean
    requiredMessage?: string
    disabled?: boolean
    position?: string
}

export interface CheckboxGroupFieldState<V> {
    errorText?: string,
    selectedValue: V[]
}

export class CheckboxGroupField<V> extends React.Component<CheckboxGroupFieldProps<V>, CheckboxGroupFieldState<V>> implements IField {
  input: React.RefObject<any> = React.createRef()

  constructor(props?: CheckboxGroupFieldProps<V>, context?: any) {
    super(props, context)

    this.state = {
      selectedValue: this.props.value,
    }
  }

  componentDidUpdate(prevProps: CheckboxGroupFieldProps<V>, prevState: CheckboxGroupFieldState<V>) {
    if (this.props.value != prevProps.value) {
      if (this.state.errorText) {
        this.validate(() => { })
      }
    }
  }

  renderCheckbox(option: Option<V>) {
    const { selectedValue } = this.state
    return (
      <Checkbox
        id={`${this.props.id}_${option.value}`}
        value={selectedValue.includes(option.value)}
        label={option.label}
        onChange={(checked:boolean) => {
          let newSelectedValue = selectedValue ?? []
          if (checked) {
            if (!newSelectedValue.includes(option.value)) {
              newSelectedValue.push(option.value)
            }
          } else {
            newSelectedValue = newSelectedValue.filter((v) => v !== option.value)
          }
          this.setState({ selectedValue: newSelectedValue })
          this.props.onChange(newSelectedValue)
        }}
        disabled={this.props.disabled}
      />
    )
  }

  render() {
    if (this.props.preview) {
      const value: Option<V>[] = []
      if (this.props.dataSource && this.props.value) {
        for (const data of this.props.dataSource) {
          if (this.props.value.indexOf(data.value) >= 0) {
            value.push(data)
          }
        }
      }

      let temp = ''
      for (const v of value) {
        if (temp.length > 0) {
          temp += ', '
        }
        temp += v.label
      }
      return (
        <FormItem {...this.props} inputId={this.props.id} errorMessage={this.state.errorText}>
          <div className="form-value">{temp || '--'}</div>
        </FormItem>
      )
    }

    return (
      <FormItem {...this.props} inputId={this.props.id}>
        {this.props.dataSource.map((option) => this.renderCheckbox(option))}
        <ErrorText text={this.state.errorText} />
      </FormItem>
    )
  }

  focus() {
    if (this.input.current) {
      const selectElement = this.input.current as any
      if (selectElement && selectElement.focus) {
        selectElement.focus()
      }
    }
  }

  hasValue(): boolean {
    let res = false
    if (this.props.dataSource && this.props.value) {
      for (const data of this.props.dataSource) {
        if (this.props.value.indexOf(data.value) >= 0) {
          res = true
          break
        }
      }
    }
    return res
  }

  getErrorText(): string {
    if (this.props.required === true) {
      if (!this.hasValue()) {
        return getRequiredError(this.props)
      }
    }
    return null
  }

  validate(callback: { (res: boolean): any }, focus?: boolean) {
    const errorText = this.getErrorText()
    this.setError(errorText, () => {
      if (this.props.errorMessage || errorText) {
        if (focus === true) {
          this.focus()
        }
      }
      callback && callback(!((this.props.errorMessage || errorText)))
    })
  }

  setError(errorText?: string, callback?: { (): any }) {
    this.setState({ errorText }, callback)
  }
}

export class TextCheckboxGroupField extends CheckboxGroupField<string> {
}

export class NumericCheckboxGroupField extends CheckboxGroupField<number> {
}
